import React from "react";
import { useT } from "../../i18n/useT";
import { useTheme } from "../../theme/useTheme";

const ThemeSwitcher = () => {
  const { theme, toggle } = useTheme();
  const t = useT();
  const label = t("nav.toggleTheme");
  const iconClass = theme === "dark" ? "fa fa-sun-o" : "fa fa-moon-o";
  return (
    <button
      type="button"
      onClick={toggle}
      className="btn btn-sm btn-outline-secondary"
      aria-label={label}
      title={label}
    >
      <i className={iconClass} aria-hidden="true"></i>
    </button>
  );
};

export default ThemeSwitcher;
